/**
 * The portal's subscription page (customer/subscription.blade.php).
 *
 * Everything it needs from PHP arrives in `window.pwContext.subscription`, which
 * CustomerController::subscription() fills, so the blade carries markup only. The page is part of the
 * portal bundle that every portal page loads, so it does nothing without that context.
 *
 * Its translations are keyed as the language file names them (App\Queries\Translations).
 */

(function () {
    /**
     * @typedef {Object<string, string>} PortalTranslations
     * @typedef {{id: number, plan_id: ?number, edit_blocked: boolean, paused: boolean,
     *     cancellation_requested: boolean, cancellation_type: ?string,
     *     translations: PortalTranslations}} SubscriptionPageContext
     *
     * @returns {?SubscriptionPageContext}
     */
    function subscriptionPageContext() {
        return (window.pwContext && window.pwContext.subscription) || null;
    }

    $(document).ready(function () {
        var page = subscriptionPageContext();
        if (!page) {
            return;
        }

        // Bound here rather than from an onclick attribute: this file arrives with app.min.js at the end of
        // the page, and an attribute naming a function it defines throws when clicked before then.
        // Each button is rendered only where the merchant allows that action, hence `?.`.
        document.getElementById("pw-skip-installment")?.addEventListener("click", skipInstallment);
        document.getElementById("pw-toggle-paused")?.addEventListener("click", togglePaused);
        document.getElementById("pw-toggle-cancelled")?.addEventListener("click", toggleCancelled);

        makeCustomerDataTable("#pw-portal-datatable-subscription-invoices");

        function loadSubscriptionQuestions() {
            // Stays on jQuery: $.ajaxSetup() adds the X-Session-Token header a cookie-blocked embed needs, and .html()
            // runs the <script> tags in the returned questions, which setting innerHTML would not.
            $.ajax({
                url: "/profile-questions",
                data: {
                    // The plan dropdown is hidden when there is nothing to switch to; the questions still follow the current plan.
                    plan_id: $("select[name=plan_id]").val() || page.plan_id,
                    subscription_id: page.id,
                    address_id: $("select[name=address_id]").val(),
                },
                success: function (data) {
                    $("#subscription-questions").html(data);
                    if (typeof setHeight === "function") {
                        setHeight();
                    }
                },
            });
        }

        // The profile questions depend on the plan and the address, and the plan dropdown may be hidden.
        document.querySelectorAll("select[name=plan_id], select[name=address_id]").forEach(function (select) {
            select.addEventListener("change", loadSubscriptionQuestions);
        });
        loadSubscriptionQuestions();

        if (page.edit_blocked) {
            document.getElementById("subscription-form").addEventListener("submit", function (e) {
                e.preventDefault();
                Messenger({ extraClasses: "messenger-fixed messenger-on-right messenger-on-top" }).post({
                    message: page.translations.edit_held_subscription_disabled,
                    type: "error",
                });
                scrollPortalFrameIntoView();
            });
        }

        acceptLargeQty();
    });

    /**
     * The confirm dialogs behind the page's buttons. Which question each one asks follows the subscription's
     * state, which the page context carries, so the markup only says which button was pressed.
     */
    function togglePaused() {
        var page = subscriptionPageContext();
        if (page) {
            confirmAndSubmit(page.paused ? page.translations.resume_sub_confirm : page.translations.pause_sub_confirm, "pw-toggle-paused-form");
        }
    }

    function toggleCancelled() {
        var page = subscriptionPageContext();
        if (!page) {
            return;
        }
        // A cancellation that is already asked for is undone; otherwise the plan says when it takes effect.
        var key = page.cancellation_requested
            ? "undo_cancel_subscription"
            : "cancel_subscription" + (page.cancellation_type ? "_" + page.cancellation_type : "");
        confirmAndSubmit(page.translations[key], "pw-toggle-cancelled-form");
    }

    function skipInstallment() {
        var page = subscriptionPageContext();
        if (page) {
            confirmAndSubmit(page.translations.skip_installment, "pw-skip-installment-form");
        }
    }

    /**
     * @param {string} message
     * @param {string} formId
     */
    function confirmAndSubmit(message, formId) {
        bootbox.confirm(message, function (result) {
            if (result) {
                document.forms.namedItem(formId)?.submit();
            }
        });
    }
})();
